import React, { Component } from "react";
import { connect } from "react-redux";
import BigCalendar from "react-big-calendar";
import ContentHeader from "./ContentHeader";
import moment from "moment";
import { newPrayer, editPrayer, hideModal } from "../actions/prayers";
import PrayerModal from "./PrayerModal";
import { list, create, update } from "../actions";

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

const PrayersCalendar = props => {
  const { prayers, onSelectEvent } = props;
  return (
    <div className="calendar-container">
      <BigCalendar
        selectable
        views={["month"]}
        events={prayers}
        defaultView="month"
        defaultDate={new Date()}
        onSelectEvent={prayer => onSelectEvent(prayer)}
      />
    </div>
  );
};

class Prayers extends Component {
  componentDidMount() {
    this.props.fetchPrayers();
  }

  render() {
    return (
      <div>
        <ContentHeader title="Prayers">
          <span className="pull-right">
            <button className="btn btn-primary" onClick={this.props.newPrayer}>
              Add Prayer
            </button>
          </span>
        </ContentHeader>

        <PrayersCalendar
          prayers={this.props.prayers}
          onSelectSlot={this.props.newPrayer}
          onSelectEvent={this.props.editPrayer}
        />

        <PrayerModal
          showModal={this.props.showPrayerModal}
          hideModal={this.props.hideModal}
          savePrayer={this.props.savePrayer}
          currentPrayer={this.props.currentPrayer}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { list, currentPrayer, showPrayerModal } = state.prayers;

  return {
    prayers: list,
    currentPrayer: currentPrayer,
    showPrayerModal: showPrayerModal,
    preachers: state.preachers.list
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchPrayers() {
      dispatch(list("prayers"));
    },
    newPrayer(prayerDetails) {
      dispatch(newPrayer(prayerDetails));
    },
    editPrayer(prayerDetails) {
      dispatch(editPrayer(prayerDetails));
    },
    hideModal() {
      dispatch(hideModal());
    },
    savePrayer(data) {
      if (data.id) {
        dispatch(update("prayer", data));
      } else {
        dispatch(create("prayer", data));
      }
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Prayers);




// WEBPACK FOOTER //
// ./src/components/Prayers.js